import { sortBy, uniqBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useTemplatesCRUDActions } from '@mm/state/actions/TemplatesCRUDActions';
import { TemplateModel } from '@mm/state/model/TemplateModel';

const FETCH_PAGE_SIZE = 25;

export const useTemplateFetchHook = (sample: boolean) => {
  const [templates, setTemplates] = useState<TemplateModel[]>([]);
  const [nextPage, setNextPage] = useState(1);
  const [moreToFetch, setMoreToFetch] = useState(true);

  const { getAll } = useTemplatesCRUDActions();

  const appendTemplates = (templatesToAppend: TemplateModel[]) => {
    setTemplates(oldTemplates => {
      return sortBy(
        uniqBy([...templatesToAppend, ...oldTemplates], t => t.id),
        t => t.name.toLowerCase(),
      );
    });
  };

  const fetchMore = async () => {
    if (!moreToFetch) {
      return;
    }
    const loadedTemplatesResponse = await getAll(
      sample,
      nextPage,
      FETCH_PAGE_SIZE,
    );
    if (loadedTemplatesResponse) {
      setMoreToFetch(!loadedTemplatesResponse.pagination.isLastPage);
      setNextPage(loadedTemplatesResponse.pagination.page + 1);
      appendTemplates(loadedTemplatesResponse.templates);
    }
  };

  const removeTemplate = (templateId: number) => {
    setTemplates(templates => templates.filter(t => t.id !== templateId));
  };

  const addTemplate = (newTemplate: TemplateModel) => {
    appendTemplates([newTemplate]);
  };

  useEffect(() => {
    fetchMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    templates,
    fetchMore,
    moreToFetch,
    removeTemplate,
    addTemplate,
  };
};
